export * from "./components/rating";
export * from "./rating.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/rating/index.js
// module id = 507
// module chunks = 0